import type { ReactElement } from "react";
import { Auswahl } from "@kundeninfo/ui/me-design";
import { HISTORICAL_TEXT as T, KIND_FILTER_VALUES } from "./texts.js";
import type { KindFilter } from "./texts.js";
import "./historical.css";

/** Die Werte des Filters als Suchparameter: „alle“ geht gar nicht erst mit (der Server nimmt dann ALL). */
export const kindParam = (value: KindFilter): { kind?: "REAL" | "HISTORICAL" } => (value === "ALL" ? {} : { kind: value });

/** Die feste Breite der Auswahl — „Art: ohne historische“ samt Pfeil, ohne dass der Pfeil auf dem Rand liegt (Sichtprobe
 *  Task 29, auch WebKit). Dieselbe Zahl steht als `inline-size` in historical.css. */
export const KIND_FILTER_WIDTH = "14em";

/**
 * Die Bereichsauswahl „Art: alle | ohne historische | nur historische“ (Spec „Historische Vorgänge anlegen und
 * anzeigen“) — eine Auswahl für Angebots- und Auftragsbereich. Feste Breite: Ein gewählter Wert kippt die Leiste nie
 * (Hausregel 20.10.2026); die Beschriftung hört die Vorlesestimme, sichtbar steht sie in der Option.
 */
export function KindFilterSelect(p: { id: string; value: KindFilter; disabled: boolean; onChange: (value: KindFilter) => void }):
    ReactElement {
  return (
    <Auswahl id={p.id} name={p.id} className="hist__kind" kompakt breite={KIND_FILTER_WIDTH} beschriftung={T.kindFilter}
      wert={p.value} gesperrt={p.disabled}
      onGeaendert={(d) => p.onChange(KIND_FILTER_VALUES.find((k) => k === d.wert) ?? "ALL")}>
      {KIND_FILTER_VALUES.map((k) => <option key={k} value={k}>{T.kindOption(T.kind[k])}</option>)}
    </Auswahl>
  );
}
